import {brand, Branded, string, TypeOf} from 'io-ts';

interface UserInputNonNegativeDoubleStringBrand {
    readonly UserInputNonNegativeDoubleString: unique symbol;
}

export const isUserInputNonNegativeDoubleString = (
    input: string
): input is Branded<string, UserInputNonNegativeDoubleStringBrand> => {
    if (!/^\d*[.,]?\d*$/.test(input)) {
        return false;
    }
    return input.replace(',', '.').split('.')[0].length <= 10;
};

// FIXME user can copy-paste value from different locale (e.g. with spaces as group separators, comma as decimal separator)
export const UserInputNonNegativeDoubleString = brand(
    string,
    isUserInputNonNegativeDoubleString,
    'UserInputNonNegativeDoubleString'
);

export type UserInputNonNegativeDoubleString = TypeOf<typeof UserInputNonNegativeDoubleString>;
